import { patchFetch } from './fetchPatch/fetchPatch';
import { patchXhr } from './xhrPatch/xhrPatch';

patchFetch();
patchXhr();
